import { useState } from "react";
import { Plane, Calendar, Users, ArrowRight } from "lucide-react";
import MspShell from "../../components/msp/MspShell";

const TABS = ["Round Trip", "One Way", "Multi-City"];

export default function MspFlights() {
  const [t, setT] = useState("Round Trip");
  return (
    <MspShell title="Flights" testid="msp-flights">
      <div className="grid grid-cols-3 rounded-2xl bg-white border border-slate-200 p-1" data-testid="msp-flights-tabs">
        {TABS.map((x) => (
          <button key={x} onClick={() => setT(x)} data-testid={`msp-flights-tab-${x.toLowerCase().replace(/\s+/g,"-")}`}
            className={`py-2.5 rounded-xl text-sm font-700 transition ${t === x ? "bg-blue-600 text-white shadow" : "text-slate-500 hover:text-slate-800"}`}>
            {x}
          </button>
        ))}
      </div>

      <div className="bg-white rounded-3xl border border-slate-200 p-5 space-y-4 shadow-sm">
        <div>
          <label className="text-xs font-700 text-slate-500 uppercase tracking-wider">From</label>
          <div className="mt-2 flex items-center gap-2 border-b border-slate-200 py-2">
            <Plane className="w-4 h-4 text-blue-600" />
            <input data-testid="msp-flight-from" defaultValue="Seattle (SEA)"
              className="flex-1 bg-transparent outline-none text-slate-800" />
          </div>
        </div>
        <div>
          <label className="text-xs font-700 text-slate-500 uppercase tracking-wider">To</label>
          <div className="mt-2 flex items-center gap-2 border-b border-slate-200 py-2">
            <Plane className="w-4 h-4 text-blue-600 rotate-90" />
            <input data-testid="msp-flight-to" defaultValue="Tokyo (NRT)"
              className="flex-1 bg-transparent outline-none text-slate-800" />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-xs font-700 text-slate-500 uppercase tracking-wider">Depart</label>
            <div className="mt-2 flex items-center gap-2 border-b border-slate-200 py-2">
              <Calendar className="w-4 h-4 text-blue-600" />
              <input data-testid="msp-flight-depart" defaultValue="Mar 27, 2027"
                className="flex-1 bg-transparent outline-none text-slate-800 min-w-0" />
            </div>
          </div>
          <div>
            <label className="text-xs font-700 text-slate-500 uppercase tracking-wider">Return</label>
            <div className="mt-2 flex items-center gap-2 border-b border-slate-200 py-2">
              <Calendar className="w-4 h-4 text-blue-600" />
              <input data-testid="msp-flight-return" defaultValue="Apr 5, 2027"
                className="flex-1 bg-transparent outline-none text-slate-800 min-w-0" />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-xs font-700 text-slate-500 uppercase tracking-wider">Travelers</label>
            <div className="mt-2 flex items-center gap-2 border-b border-slate-200 py-2">
              <Users className="w-4 h-4 text-blue-600" />
              <input data-testid="msp-flight-travelers" defaultValue="2 Adults, 0 Children"
                className="flex-1 bg-transparent outline-none text-slate-800 min-w-0" />
            </div>
          </div>
          <div>
            <label className="text-xs font-700 text-slate-500 uppercase tracking-wider">Cabin Class</label>
            <div className="mt-2 flex items-center gap-2 border-b border-slate-200 py-2">
              <Plane className="w-4 h-4 text-blue-600" />
              <input data-testid="msp-flight-cabin" defaultValue="Economy"
                className="flex-1 bg-transparent outline-none text-slate-800 min-w-0" />
            </div>
          </div>
        </div>
        <button data-testid="msp-flight-search"
          className="w-full inline-flex items-center justify-center gap-2 rounded-2xl bg-blue-600 text-white py-3.5 font-700 hover:brightness-110">
          Search Flights <ArrowRight className="w-4 h-4" />
        </button>
      </div>

      <div className="rounded-3xl overflow-hidden border border-slate-200 h-40 relative bg-slate-100">
        <img src="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=1200&q=70"
          alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-white/90 to-transparent" />
        <div className="relative p-5 max-w-[70%]">
          <div className="font-serif font-800 text-lg text-blue-900 leading-tight">Find the best flights for your next adventure.</div>
        </div>
      </div>
    </MspShell>
  );
}
